export const DEFAULT_DASHBOARD_PARAMETERS: DashboardConfiguration = {
    language: '',
    timezone: '',
    hotel: {
        roomCount: 0
    },
    settings: {
        baseUrl: process.env.REACT_APP_BASE_URL, // http://localhost/dashboard
        apiUrl: process.env.REACT_APP_API_URL, // http://localhost:5285
        extranet: process.env.REACT_APP_EXTRANET,
        extranetUrl: process.env.REACT_APP_EXTRANET_URL, // /Home/DashboardStats
        randomData: process.env.REACT_APP_RANDOM_DATA
    },
    labels: {
        pastWeek: 'The past week',
        pastMonth: 'The past month',
        nextXDays: 'Next {number} days',
        theNextXDays: 'The next {number} days',
        period: 'period',
        Stays: {
            title: 'Stays',
            bookingLink: 'See my reservations',
            arrivals: 'Arrivals today',
            departures: 'Departures',
            arrivalsTitle: '{number} arrivals scheduled for today',
            departuresTitle: '{number} departures scheduled for today',
            guestCount: '{guestCount} guests',
            roomCount: '{roomCount} rooms'
        },
        BookingActivity: {
            title: 'Booking Activity',
            subtitle: 'Showcase your past activity from financial perspective',
            revenues: 'Revenues',
            cancellations: 'Cancellations',
            dailyPickUp: 'Daily pick up',
            nightsBooked: 'Nights booked',
            incomes: 'Incomes',
            nightsCancelled: 'Nights cancelled',
            revenueLost: 'Revenue lost',
            fullReport: 'See full report',
            DataCruncherTitle: 'Fancy some more data to crunch ?',
            DataCruncherText: 'Check out our data intelligence products and how you can improve your business',
            DataCruncherLink: 'Discover now'
        },
        OccupationPlanning: {
            title: 'Occupation planning',
            subtitle:
                'Forecast occupation on your property according to reservations gathered at D-EDGE. It is compared to the same period last year (2022).',
            digitalOccupancyRate: 'Digital occupancy rate',
            provisionalRevenue: 'Provisional values',
            managePlanning: 'Manage planning'
        }
    }
};
